import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { settlement_price: '', settlement_basis: '', authorization_reference: '', reason: '', confirm: '' };

export const ReconcileDialog = ({ position, onClose, onDone }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/admin/positions/${position.id}/reconcile`, form);
      toast.success('Position reconciled and recorded in the audit log');
      setForm(EMPTY);
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Reconciliation failed');
    } finally { setBusy(false); }
  };

  if (!position) return null;
  return (
    <Dialog open={!!position} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="reconcile-dialog">
        <DialogHeader><DialogTitle>Reconcile {position.symbol} position</DialogTitle></DialogHeader>
        <div className="text-xs text-slate-600 space-y-1" data-testid="reconcile-original">
          <div>{position.direction} {position.volume} @ {position.open_price} · opened {String(position.opened_at || '').slice(0, 10)}</div>
          <div>This instrument has no verified price feed. Settlement is applied only after you confirm the agreed terms below.</div>
        </div>
        <div className="space-y-3">
          <div><Label>Agreed settlement price</Label>
            <Input type="number" step="any" value={form.settlement_price} onChange={set('settlement_price')} data-testid="reconcile-price" /></div>
          <div><Label>Settlement basis</Label>
            <Input placeholder="e.g. void at open price, agreed with client" value={form.settlement_basis} onChange={set('settlement_basis')} data-testid="reconcile-basis" /></div>
          <div><Label>Authorization reference</Label>
            <Input placeholder="e.g. email / ticket id" value={form.authorization_reference} onChange={set('authorization_reference')} data-testid="reconcile-auth-ref" /></div>
          <div><Label>Reason</Label>
            <Textarea value={form.reason} onChange={set('reason')} data-testid="reconcile-reason" /></div>
          <div><Label>Type the position id to confirm: <span className="font-mono">{position.id}</span></Label>
            <Input value={form.confirm} onChange={set('confirm')} data-testid="reconcile-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="reconcile-cancel">Cancel</Button>
          <Button onClick={submit} disabled={busy || form.confirm !== position.id} data-testid="reconcile-submit">Settle position</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
